// src/pages/Checking.js
import React from 'react';
import QueuePage from './QueuePage';
export default function Checking() { return <QueuePage stage={3} />; }
